module.exports = __webpack_public_path__ + "static/media/bodycare_female.45a7466b.svg";